import { Key } from "@mui/icons-material";
import {
  CUSTOM_DATA_POINT_TYPE,
  CUSTOM_DATA_TYPE,
  SUPER_ADMIN_ROLE,
} from "../../app/Constants/Constants";
import { isEqual } from "lodash";

export const getCustomDataObj = (data) => ({
  dataPointId: data.id,
  type: data.type,
  name: data.messageName,
  collectorType: data.collectorType,
  fieldType: data.fieldType,
  definition: data.definition,
  piiHandling: data.piiHandling,
  customerCode: data.customerCode,
  collectorConfigId: data.collectorConfigId,
  status: data.status,
});

export const getCustomParam = /* istanbul ignore next */ (data) => ({
  companyId: data.companyId,
  collectorConfig: data.collectorConfig === "" ? null : data.collectorConfig,
  collectorType: data.collectorType === "" ? null : data.collectorType,
  customItemType: data.customItemType === "" ? null : data.customItemType,
  states: data.states === "" ? null : data.states,
  status: data.status === "" ? null : data.status,
});
export const fetchSourceCollectorList = (collectors) => {
  const list = collectors?.map((collector) => ({
    collectorConfiguration: {
      value: collector?.collectorConfigName,
    },
    collector: {
      value: collector?.collectorName,
    },
    lastObserved: {
      value: collector?.lastObservedOn,
    },
  }));
  return list?.sort((a, b) =>
    a?.collectorConfiguration?.value?.localeCompare(
      b?.collectorConfiguration?.value,
    ),
  );
};
export const fetchMappedKeyList = (mappedKeys, currentCustomDataType) => {
  const list = mappedKeys?.map((mappedKey) => ({
    key: {
      value:
        currentCustomDataType === "Event" &&
        mappedKey?.scope?.toLowerCase() === "sdk method"
          ? mappedKey?.key?.replace(/^custom_/i, "")
          : mappedKey?.key,
    },
    customDatapointId: {
      value: mappedKey?.customDatapointId,
    },
    collector: {
      value: mappedKey?.collectorConfigName,
    },
    configId: {
      value: mappedKey?.configId,
    },
    scope: {
      value: mappedKey?.scope,
    },
    lastObserved: {
      value: mappedKey?.lastObservedOn,
    },
    supported: {
      value: "No",
    },
    resultsLimit: {
      value: mappedKey?.resultsLimit,
    },
    isEventSpecific: {
      value: mappedKey?.isEventSpecific || false,
    },
    eventAliasId: {
      value: mappedKey?.eventAliasId,
    },
    attributeName: {
      value: mappedKey?.attribute,
    },
    elementSelectorQuery: {
      value: mappedKey?.selectorQuery,
    },
    interactionType: {
      value: mappedKey?.interactionType,
    },
    isManual: mappedKey?.isManual,
  }));
  return list?.sort((a, b) =>
    a?.collector?.value?.localeCompare(b?.collector?.value),
  );
};

export const filterBoxData = /* istanbul ignore next */ (
  applicationCollector,
  collectorConfigList,
  allCompany,
  defaultCompany,
  auth,
  popUp,
) => {
  const role = auth?.user?.roleName === SUPER_ADMIN_ROLE;
  const DPList = [];
  if (!popUp) {
    DPList.push({
      name: "Alias / Unmapped Key",
      DPValue: CUSTOM_DATA_TYPE.sort().map(
        /* istanbul ignore next */ (type) => {
          return {
            id: Math.random().toString(36).slice(2, 7),
            name: type,
            value: type,
            type: "type",
          };
        },
      ),
    });
  }
  DPList.push(
    {
      name: "Collector",
      DPValue: applicationCollector?.sort()?.map(
        /* istanbul ignore next */ (collector) => {
          return {
            id: Math.random().toString(36).slice(2, 7),
            name: collector?.collectorDescription,
            value: collector?.id,
            type: "collectors",
          };
        },
      ),
    },
    {
      name: "Collector Configuration",
      DPValue: collectorConfigList?.sort()?.map(
        /* istanbul ignore next */ (collectorConfig) => {
          return {
            id: collectorConfig?.config?.value,
            name: collectorConfig?.name?.value,
            value: collectorConfig?.config?.value,
            type: "collectorConfigs",
          };
        },
      ),
    },
  );
  if (role && defaultCompany === null) {
    DPList.push({
      name: "Customer",
      DPValue: allCompany?.sort()?.map(
        /* istanbul ignore next */ (com) => {
          return {
            id: com?.companyuuid,
            name: com?.company_name,
            value: com?.companyuuid,
            type: "customers",
          };
        },
      ),
    });
  }
  return {
    DPList,
  };
};

export const filterApiData = /* istanbul ignore next */ (filterData) => {
  let type = "";
  let dataPointType = "";
  const collectors = [];
  const collectorConfigs = [];
  const customers = [];

  let typeCount = 0;
  let dataPointTypeCount = 0;

  filterData.forEach((data) => {
    switch (data.type) {
      case "type":
        typeCount++;
        if (typeCount === 1) {
          type = data.value;
        }
        break;
      case "collectors":
        collectors.push(data.value);
        break;
      case "collectorConfigs":
        collectorConfigs.push(data.value);
        break;
      case "customers":
        customers.push(data.value);
        break;
      default:
        break;
    }
  });

  const result = {
    collectors,
    collectorConfigs,
    customers,
  };

  if (typeCount === 1) {
    result.type = type;
  }

  if (dataPointTypeCount === 1) {
    result.dataPointType = dataPointType;
  }

  return result;
};
export const customFilterData = (data) => {
  return {
    id: data?.config?.value,
    name: data?.name?.value,
    value: data?.config?.value,
    type: "collectorConfigs",
  };
};
export const convertSourceToMappedKeyList = (mappedKeys, name, scope, type) => {
  const list = mappedKeys?.map((mappedKey) => ({
    key: {
      value:
        type === "Event" && scope?.toLowerCase() === "sdk method"
          ? name?.replace(/^custom_/i, "")
          : name,
    },
    customDatapointId: {
      value: mappedKey?.customDatapointId,
    },
    collector: {
      value: mappedKey?.collectorConfigName,
    },
    scope: {
      value: scope,
    },
    lastObserved: {
      value: mappedKey?.lastObservedOn,
    },
    supported: {
      value: "No",
    },
  }));
  return list?.sort((a, b) =>
    a?.collector?.value?.localeCompare(b?.collector?.value),
  );
};

export const convertConfigToMappedKeyList = (
  item,
  key,
  existingMappedKeys = [],
) => {
  if (!item) return [];
  const newConfigId = item?.config?.value;
  const newKey = key;
  const isDuplicate = existingMappedKeys.some(
    (existing) =>
      existing?.configId?.value === newConfigId &&
      existing?.key?.value === newKey,
  );
  if (isDuplicate) {
    return [];
  }
  const mappedKey = {
    key: {
      value: key,
    },
    configId: {
      value: item?.config?.value,
    },
    collector: {
      value: item?.name?.value,
    },
    scope: {
      value: "Element Query",
    },
    lastObserved: {
      value: "Never",
    },
    supported: {
      value: "No",
    },
    newKeyFlag: {
      value: true,
    },
  };
  return [mappedKey];
};

export const groupByTypeFilter = (input) => {
  return input?.reduce((acc, item) => {
    if (!acc[item?.type]) {
      acc[item?.type] = [];
    }
    acc[item?.type].push(item?.value);
    return acc;
  }, {});
};

export const filterCustomDataDetails = (data) => {
  if (!data || !data.aliasId) return data;

  const {
    aliasId,
    type,
    displayName,
    definition,
    fieldType,
    mappedKeys,
    masterKey,
    messageName,
    stringType,
    enumeratedValues,
    unit,
    numberType,
    decimalPlaces,
    scaleMin,
    scaleMax,
    bqConnectorConfigCount,
    datapipeCount,
  } = data;

  const result = {
    aliasId,
    type,
    definition,
    displayName,
    fieldType,
    mappedKeys,
    masterKey,
    messageName,
    bqConnectorConfigCount,
    datapipeCount,
  };

  if (fieldType === "string" || fieldType === "array of string") {
    result.stringType = stringType;
    result.enumeratedValues =
      Array.isArray(enumeratedValues) &&
      enumeratedValues.length === 1 &&
      enumeratedValues[0] === ""
        ? []
        : enumeratedValues;
  } else if (fieldType === "number") {
    result.unit = unit;
    result.numberType = numberType;
    result.decimalPlaces = decimalPlaces;
    result.scaleMin = scaleMin;
    result.scaleMax = scaleMax;
  }

  return result;
};

export const aliasChangeTblLog = [
  {
    key: "Field",
    label: "Field",
  },
  {
    key: "Previous_Value",
    label: "Previous Value",
  },
  {
    key: "Empty_Value",
    label: "",
  },
  {
    key: "New_Value",
    label: "New Value",
  },
];

export const getEventAliasItems = (arr) => {
  return arr
    ?.filter((item) => item?.alias)
    ?.map((item) => ({
      label: item?.displayName,
      value: item?.aliasId,
    }));
};

export const CustomDataDialogDetails = (status, data, checkCount) => {
  switch (status) {
    case "deleteAlias": {
      const actionContent =
        checkCount?.pipeCount > 0 || checkCount?.bqCount > 0
          ? `Warning: This alias is currently active in ${
              checkCount?.pipeCount || 0
            } ${
              checkCount?.pipeCount > 1 ? "Data Pipes" : "Data Pipe"
            }  and mapped in ${checkCount?.bqCount || 0} ${
              checkCount?.bqCount > 1 ? "Connectors" : "Connector"
            }. Deleting it will impact downstream data delivery. Its underlying keys will revert to an unmapped state.`
          : "Are you sure you want to delete this alias? Associated keys will revert to an unmapped state.";
      return {
        title: `Delete ${data?.displayName}?`,
        content: actionContent,
        actionButtonNames: ["cancel", "delete alias"],
      };
    }
    case "reservedDataDictionary": {
      const actionContent = `The ${data?.masterKey} master key is a reserved Datazoom dictionary key. Please use a different master key.`;
      return {
        title: "Reserved master key",
        content: actionContent,
        actionButtonNames: ["ok"],
      };
    }
  }
};

export const customCheckCountData = (data) => {
  return {
    pipeCount: data?.data?.datapipeCount,
    bqCount: data?.data?.bqConnectorConfigCount,
    success: data?.success,
  };
};
